<div class="fn-filters-modal">
  <div class="fn-filters-modal__header">
    <div class="fn-filters-modal__title">
      <div>{{ "IP.FILTERS_MODAL.FILTER" | translate }}</div>
    </div>
    <img
      src="../../../../../../assets/new-styles/icons/buttons/close-icon.svg"
      mat-dialog-close
      class="fn-filters-modal__header__icon"
    />
  </div>
  <form enctype="multipart/form-data" [formGroup]="datesForm" novalidate>
    <div class="fn-filters-modal__dates">
      <div class="fn-filters-modal__dates--fn_inputs-filters_dates">
        <label
          for="startDateInput"
          class="fn-filters-modal__dates--fn_inputs-filters_dates-input__placeholder"
          >{{ "IP.FILTERS_MODAL.START" | translate }}</label
        >
        <input
          type="date"
          [max]="maxDate"
          (change)="onStartDateChange()"
          #startDateInput
          required="true"
          class="fn-filters-modal__dates--fn_inputs-filters_dates-input"
          formControlName="startDate"
        />
        <img
          src="../../../../assets/new-styles/icons/buttons/calendar-icon.svg"
          alt=""
          (click)="openCalendar(startDateInput)"
        />
      </div>
      <div class="fn-filters-modal__dates--fn_inputs-filters_dates">
        <label
          for="endDateInput"
          class="fn-filters-modal__dates--fn_inputs-filters_dates-input__placeholder"
          >{{ "IP.FILTERS_MODAL.END" | translate }}</label
        >
        <input
          type="date"
          class="fn-filters-modal__dates--fn_inputs-filters_dates-input"
          formControlName="endDate"
          [min]="minEndDate"
          required="true"
          #endDateInput
        />
        <img
          src="../../../../assets/new-styles/icons/buttons/calendar-icon.svg"
          alt=""
          (click)="openCalendar(endDateInput)"
        />
      </div>
    </div>
    <div class="fn-filters-modal__search" *ngIf="!this.data.hideSearchBox">
      <label class="fn-filters-modal__search__placeholder">Buscar</label>
      <input type="text" class="fn-filters-modal__search__input" formControlName="searchValue"/>
    </div>
    <div class="fn-filters-modal__btn">
      <button (click)="applyFilters()">Aplicar</button>
    </div>
  </form>
</div>
